import { render, staticRenderFns } from "./CharacterMatch.vue?vue&type=template&id=4577c51b&"
import script from "./CharacterMatch.vue?vue&type=script&lang=js&"
export * from "./CharacterMatch.vue?vue&type=script&lang=js&"
import style0 from "./CharacterMatch.vue?vue&type=style&index=0&id=4577c51b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports